// extracted by mini-css-extract-plugin
export var coverImageCaption = "Intro-module--coverImageCaption--fymSq";
export var coverImageCaptionMobile = "Intro-module--coverImageCaptionMobile--TpTSM";
export var coverImageWrapper = "Intro-module--coverImageWrapper--trYTz";
export var introCard = "Intro-module--introCard--eKw7a";
export var introCardInner = "Intro-module--introCardInner--KPfu+";
export var introCoverImage = "Intro-module--introCoverImage--PGPrO";
export var introHeadline = "Intro-module--introHeadline--oXicz";
export var introNavigation = "Intro-module--introNavigation--kF45r";
export var introText = "Intro-module--introText--kBfKe";
export var introTextWrapper = "Intro-module--introTextWrapper--GPIPm";
export var root = "Intro-module--root--H-BGn";
export var share = "Intro-module--share--zD1o5";
export var title = "Intro-module--title--PfLdc";
export var titleMain = "Intro-module--titleMain--jJE-4";
export var titleNumber = "Intro-module--titleNumber--L4Ond";
export var titleSmaller = "Intro-module--titleSmaller--3Vla3";